export default {
  user_type: [
    { id: 0, title: "Passenger", label: "Passenger", value: "passenger" },
    { id: 3, title: "Driver", label: "Driver", value: "driver" }
  ],
  logo_url:"logo.png",
  favicon_url:"favicon.png",
};
